import { requestService } from '../helpers/request.service';

export const messageService = {
    sendMessage,
};

function sendMessage(params) {
    return requestService.post({
        methodName: '/Contact/SendMessage',
        body: params
    });
}